//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { baseInfo } from '@/api/apis';
import { updateStatus as _updateStatus, userInfo } from '@/api/appliCustomerManage';
export default {
  name: 'userInfo',
  data: function data() {
    return {
      activeName: 'first',
      //基本信息
      // 参数
      userId: '',
      // 页面数据
      appliUserInfoResDto: {
        appliUserPlatDto: {},
        userStatusList: []
      },
      businessNatures: [],
      // 经营性质
      identifyType: [],
      // 法人证件类型
      companyType: [],
      // 公司类型
      listOpt: [{
        value: '1',
        label: '是'
      }, {
        value: '0',
        label: '否'
      }]
    };
  },
  mounted: function mounted() {
    this.userId = this.$route.params.userId;
  },
  created: function created() {
    var _this = this;

    // 获取基础数据下拉列表的值
    baseInfo({}).then(function (res) {
      console.log('res结果', res);

      if (res.rtnCode === '0000') {
        _this.businessNatures = res.businessNature;
        _this.identifyType = res.personIdentifyType;
        _this.companyType = res.companyType;
      }
    });
    console.log('111ccc');
    this.userId = this.$route.params.userId;
    this.getData();
  },
  methods: {
    updateStatus: function updateStatus(data, type) {
      var _this2 = this;

      var param = data;
      param.creditStatus = type;

      _updateStatus(param).then(function (res) {
        _this2.$message({
          type: 'success',
          message: '修改成功'
        });
      });
    },
    // 获取列表数据
    getData: function getData() {
      var _this3 = this;

      userInfo({
        userId: this.userId
      }).then(function (res) {
        _this3.appliUserInfoResDto = res;
      });
    },
    handleClose: function handleClose(done) {
      var _this4 = this;

      this.$confirm('确认关闭？').then(function (_) {
        for (var key in _this4.ruleForm) {
          _this4.ruleForm[key] = '';
        }

        done();
      }).catch(function (_) {});
    }
  }
};